import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconArrowAlignHorizontalCentre24(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={24}
            className={customClassName}
            name="IconArrowAlignHorizontalCentre24"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M12.75 2.75a.75.75 0 0 0-1.5 0v4.94L9.03 5.47a.75.75 0 0 0-1.06 1.06l3.535 3.536.53.53.53-.53 3.536-3.536a.75.75 0 1 0-1.06-1.06L12.75 7.76zM4 12a.75.75 0 0 1 .75-.75h14.5a.75.75 0 0 1 0 1.5H4.75A.75.75 0 0 1 4 12m8.071 10a.75.75 0 0 1-.75-.75v-5.01l-2.29 2.29a.75.75 0 0 1-1.061-1.06l3.535-3.536.53-.53.53.53 3.536 3.536a.75.75 0 1 1-1.06 1.06l-2.22-2.22v4.94a.75.75 0 0 1-.75.75"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconArrowAlignHorizontalCentre24);
